/**
 * @desc 监管日志
 */
import React from 'react';
import { Table } from 'antd';
import { ReportDateTypeText, ReportTypeText } from '../../../constants/info';
import { dateFormat } from '../../../utils/formatter';
import Pagination from '../../common/pagination/Pagination';
import TableSearch from '../../common/tableSearch/TableSearch';
import SearchBar from '../common/searchBar/SearchBar';
import DetailModal from './index/DetailModal';
import { getLogList } from '../../../services/user';

export default class Log extends TableSearch {
    constructor(props) {
        super(props);
        this.server = getLogList;
        this.state = {
            pageNum: 1,
            pageSize: 10,
            total: 0,
            searchParams: {},
            loading: true,
            data: [],
            visible: false,
            activeItem: {},
            modalKey: +new Date()
        };
    }

    getColumns = () => {
        return [{
            title: '序号',
            dataIndex: 'index',
            width: 60
        }, {
            title: '股票代码',
            dataIndex: 'stockCode',
            width: 120
        }, {
            title: '公司简称',
            dataIndex: 'sesName'
        }, {
            title: '监管年份',
            dataIndex: 'reportYear',
            width: 130
        }, {
            title: '报表类型',
            dataIndex: 'reportDateType',
            render: (v, d) => ReportDateTypeText[v] + ReportTypeText[d.reportType]
        }, {
            title: '最新日志时间',
            dataIndex: 'createTime',
            width: 170,
            render: dateFormat
        }, {
            title: '日志内容',
            dataIndex: 'detail',
            width: 120,
            render: (v, d) => <div className="operation">
                <a href="javascript:void(0)" className="blue-font" onClick={() => this.showModal(d)}>详情</a>
            </div>
        }];
    };

    render() {
        const { data, pageNum, pageSize, total, loading, visible, activeItem, modalKey } = this.state;
        return (
            <div>
                <SearchBar onSearch={this.onSearch}/>

                <Table
                    rowKey="id"
                    loading={loading}
                    pagination={false}
                    columns={this.getColumns()}
                    dataSource={data}
                    bordered
                    footer={() => <Pagination total={total} current={pageNum} pageSize={pageSize} onChange={this.pageChange}/>}
                />
                <DetailModal
                    key={modalKey}
                    visible={visible}
                    item={activeItem}
                    onCancel={this.hideModal}
                    onDelAll={this.delRefresh}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/personal/log/Index.jsx